import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Sprite, Text } from '@pixi/react';
import gsap from 'gsap';

import { jackPotStore } from '../../../../../store/jackPotStore';
import { userInfoStore } from '../../../../../store/userInfoStore';
import { menuSectionStore } from '../../../../../store/menuSectionStore';

import { isMobile } from '../../../../../core/helpers/isMobile';
import { isoStandard } from '../../../../../core/helpers/isoStandard';
import { parseNumberPrecisionByDoteCount } from '../../../../../core/helpers/parseNumberByPrecision';

const JackPotInfoItem = observer(
  ({
    x,
    id,
    amount,
    iconImage,
    inputImage,
    containerName,
    handlePointerOver,
    handlePointerLeave,
  }) => {
    const [amountValue, setAmountValue] = useState(0);
    const textRef = useRef(null);
    const secretIdTextRef = useRef(null);
    const { isShowMenuPopup } = menuSectionStore;

    const {
      jackpotWinInfo: { secretId, jackpotCard },
    } = jackPotStore;

    useEffect(() => {
      if (amount) {
        // eslint-disable-next-line prefer-const
        let { precision, rate } = userInfoStore;
        precision = rate < 0.01 ? 0 : precision;
        const isInteger = amount === Math.floor(amount);
        gsap.to(textRef.current, {
          textContent: amount,
          duration: 0.8,
          ease: 'none',
          snap: { textContent: isInteger ? 1 : 1 / 10 ** userInfoStore.precision },
          stagger: {
            each: 1.0,
            onUpdate: function () {
              setAmountValue(
                isoStandard(
                  +parseNumberPrecisionByDoteCount(+this.targets()[0].textContent, 1, precision)
                )
              );
            },
          },
        });
      } else {
        textRef.current.textContent = 0;
      }
    }, [amount]);

    useEffect(() => {
      if (secretId) {
        gsap
          .timeline({
            repeat: 3,
          })
          .to(secretIdTextRef.current, {
            alpha: 1,
            duration: 1,
          })
          .to(secretIdTextRef.current, {
            alpha: 0,
            duration: 1,
          });
      }
    }, [secretId]);

    return (
      <Container
        x={x}
        id={id}
        interactive
        name={containerName}
        visible={!isShowMenuPopup}
        pointermove={!isMobile() && handlePointerOver}
        pointerdown={isMobile() && handlePointerOver}
        pointerout={!isMobile() && handlePointerLeave}
      >
        <Sprite scale={0.5} texture={inputImage} />
        <Sprite x={isMobile() && 4} y={isMobile() && 4.5} scale={0.5} texture={iconImage} />
        <Text
          x={isMobile() ? 32 : 44}
          y={isMobile() ? 7 : 9}
          ref={textRef}
          resolution={2}
          text={`${amountValue}`}
          style={{ fontSize: isMobile() ? 15 : 18, fontWeight: 600, fill: 'white' }}
        />
        {secretId && jackpotCard === id && (
          <Text
            anchor={0.5}
            x={isMobile() ? (id > 2 ? 110 : 85) : 145}
            y={isMobile() ? 0 : 0}
            resolution={2}
            ref={secretIdTextRef}
            text={`${secretId}`}
            style={{ fontSize: isMobile() ? 15 : 18, fontWeight: 600, fill: 'white' }}
          />
        )}
      </Container>
    );
  }
);

export default JackPotInfoItem;
